import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface CSVProcessState {
  value: boolean;
}

const initialState: CSVProcessState = { value: false };

export const csvProcessSlice = createSlice({
  name: 'CsvProcess',
  initialState,
  reducers: {
    setCsvProcess: (state: CSVProcessState, action: PayloadAction<boolean>) => {
      state.value = action.payload;
    },
  },
});

export const selectedCsvProcess = (state: RootState) => state.csvProcess.value;

export const { setCsvProcess } = csvProcessSlice.actions;

export default csvProcessSlice.reducer;
